module.exports = __webpack_public_path__ + "img/PasswordCollection.9ffef4d3.jpg";